
const Banner = ({ text }) => {
  return (
    <section className="banner">

      <div className="banner-crop">
        <img src="/images/header/new/new_banner_squiggly.png" alt="Header Image" />
      </div>

      <div className="translucent">
        <div className="content">
          <h3>{ text }</h3>
        </div>
      </div>

    </section>
  );
}

export default Banner;